module.exports = __webpack_public_path__ + "static/media/video.127bc0bf.jpg";